import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { animateScroll } from "react-scroll";
import { constructArtificialLinkNode, getStaticPageLink } from "../../../utils/links";
import LinkWrapper from "../linkWrapper/LinkWrapper";
import Image from "../image/Image";

const Footer = ({ content, brand }) => {
    const [scroll, setScroll] = useState(0);
    const [top, setTop] = useState(0);

    const { linkGroups } = content;

    useEffect(() => {
        setTop(100);
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        animateScroll.scrollToTop();
    };

    const handleScroll = () => {
        setScroll(window.scrollY);
    };

    return (
        <footer className="footer-area bg-gray pt-100 pb-70">
            <div className="container">
                <div className="row">
                    <div className="col-lg-2 col-sm-4">
                        <div className="copyright mb-30">
                            <div className="footer-logo">
                                {(brand.logo || brand.footerLogo) && (
                                    <LinkWrapper linkNode={constructArtificialLinkNode({ value: getStaticPageLink("HOME") })}>
                                        <Image imageNode={brand.footerLogo ?? brand.logo} className="logo-img" />
                                    </LinkWrapper>
                                )}
                            </div>

                            {content.disclaimer && <p>{content.disclaimer}</p>}
                        </div>
                    </div>

                    {linkGroups &&
                        linkGroups["@nodes"].map((nodeName) => (
                            <div key={nodeName} className="col-lg-2 col-sm-4">
                                <div className="footer-widget mb-30 ml-30">
                                    <div className="footer-list">
                                        <ul>
                                            {linkGroups[nodeName]["@nodes"].map((fieldNodeName, idx) => {
                                                const field = linkGroups[nodeName][fieldNodeName];

                                                if (!field.label) return null;

                                                return (
                                                    <li key={fieldNodeName}>
                                                        {idx === 0 ? (
                                                            <div className="footer-title">
                                                                <h3>{field.label}</h3>
                                                            </div>
                                                        ) : (
                                                            <LinkWrapper linkNode={field}>{field.label}</LinkWrapper>
                                                        )}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            </div>

            <button className={`scroll-top ${scroll > top ? "show" : ""}`} onClick={() => scrollToTop()}>
                <i className="fa fa-angle-double-up"></i>
            </button>
        </footer>
    );
};

const mapStateToProps = (state) => ({
    brand: state.brandData,
});

export default connect(mapStateToProps)(Footer);
